/**
 * RESPONSIBILITY: show the opening of the church's story, and the way to the rest of it.
 *
 * A PREVIEW, NOT A COPY. The whole story is a page of its own; printing it here too
 * would be the same words in two places, and a story printed twice is a story corrected
 * once. What is shown is the start of the same value, faded off rather than cut to a
 * hand-picked sentence — a fixed excerpt needs rewriting every time the story does.
 */
import { Html } from '@framework/react';
import type { AboutStorySection } from '@app/sections';
import { Picture } from '../commons/Picture';
import { Page, hrefFor } from '../commons/pages';

export function AboutStoryTeaser({ c }: { c: AboutStorySection }) {
  const caption = c.photoName?.trim() || c.photoSince?.trim();

  return (
    <section className="ab-story">
      <div className="wrap">
        <div className="ab-story__photo-wrap">
          <Picture value={c.image} alt={c.image?.alt} className="ab-story__photo" />
          {caption && (
            <p className="ab-story__photo-overlay">
              {c.photoName && <span className="ab-story__photo-name">{c.photoName}</span>}
              {c.photoSince && <span className="ab-story__photo-since">{c.photoSince}</span>}
            </p>
          )}
        </div>

        <div className="band-head">
          {c.eyebrow && <span className="about-kicker">{c.eyebrow}</span>}
          <h2 className="about-h2">{c.heading}</h2>
        </div>

        {c.bodyHtml && (
          <div className="ab-story__origin about-excerpt">
            <Html className="md-body">{c.bodyHtml}</Html>
          </div>
        )}

        {c.moreLabel && (
          <div className="btns">
            <a className="btn btn-ghost" href={hrefFor(Page.About, 'story')}>{c.moreLabel}</a>
          </div>
        )}
      </div>
    </section>
  );
}
